import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { observable } from "mobx";
import { observer } from "mobx-react";
import classNames from "classnames";
import PropTypes from "prop-types";
import LoginForm from "../components/LoginForm";
import DomainNameUtils from "~/utils/DomainNameUtils";
import LoginStore from "../stores/LoginStore";
import FlashMessageStore from "~/stores/FlashMessageStore";
import InitialAccountSetup from "../components/InitialAccountSetup";
import CustomBrandingStyle from "~/components/CustomBrandingStyle";
import TourbuzzLoginAd from "../components/TourbuzzLoginAd";
import MyUrbanimmersiveLoginAd from "../components/MyUrbanimmersiveLoginAd";

@observer
class LoginPage extends Component {
  /**
   * @type {LoginStore}
   */
  @observable loginStore;

  constructor(props) {
    super(props);

    this.loginStore = new LoginStore();
  }

  componentDidMount() {
    const { match, t } = this.props;
    document.title = t("login:pleaseLogInDot");

    this.loginStore.reset();

    // Look for a pre-filled username in the query string
    const urlParams = new URLSearchParams(window.location.search);
    const preFilledUsername = urlParams.get("username");

    if (preFilledUsername) {
      // A pre-filled username can mean 2 things
      // 1. This is a customer and we want to send the initial setup
      // 2. This is a provider and we want to pre-fill the username
      // Case #1 is handled in the back-end for now

      this.loginStore.username = preFilledUsername;
    }

    if (match.params.promptEvenIfLoggedIn) {
      const { flashMessageStore } = this.props;
      flashMessageStore.setMessage(t("login:pleaseLoginAgainAccessArea"));
    }
  }

  continueURL() {
    const { match } = this.props;

    if (match.params.continueUrl) {
      try {
        return atob(match.params.continueUrl);
      } catch (e) {
        return "";
      }
    }

    return "";
  }

  render() {
    const { flashMessageStore } = this.props;

    const isCustomerInitialAccountSetup = window.isCustomerInitialAccountSetup || false;
    const initialAccountSetupEmail = window.initialAccountSetupEmail || "";

    return (
      <>
        <CustomBrandingStyle />
        <main
          className={classNames(
            "login custom-domain",

          )}
        >
          <div className="login-column login-modal">
            <div className="login-modal-content">
              {!isCustomerInitialAccountSetup && (
                <LoginForm
                  loginStore={this.loginStore}
                  continueURL={this.continueURL()}
                  flashMessageStore={flashMessageStore}
                />
              )}
              {isCustomerInitialAccountSetup && <InitialAccountSetup email={initialAccountSetupEmail} />}
            </div>
          </div>

        </main>
      </>
    );
  }
}

LoginPage.propTypes = {
  flashMessageStore: PropTypes.instanceOf(FlashMessageStore).isRequired,
  t: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      continueUrl: PropTypes.string,
      promptEvenIfLoggedIn: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired,
  }),
};

export default withTranslation()(LoginPage);
